module.exports = __webpack_public_path__ + "img/booking.3f3e02f3.svg";